// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2hM6Q","label":"LabeledBox_label__1D99Q"};